import React from 'react';
import { useThroughputData } from '../hooks/useThroughputData';
import { FilterBar } from '../components/throughput/FilterBar';
import { TeamSummaryBar } from '../components/throughput/TeamSummaryBar';
import { TeamLeaderboard } from '../components/throughput/TeamLeaderboard';
import { LeadSourceLeaderboard } from '../components/throughput/LeadSourceLeaderboard';
import { ThroughputFunnel } from '../components/throughput/ThroughputFunnel';
import { Loader2 } from 'lucide-react';
export function ThroughputDashboard() {
  const {
    isLoading,
    filters,
    setFilters,
    metrics,
    officers,
    filteredLeads,
    filteredOpportunities
  } = useThroughputData();
  const handleRefresh = () => {
    window.location.reload();
  };
  const handleTeamSelect = (teamLeadId: string | null) => {
    if (teamLeadId) {
      setFilters({
        ...filters,
        scopeType: 'Team Lead',
        selectedScopeId: teamLeadId
      });
    } else {
      setFilters({
        ...filters,
        scopeType: 'All',
        selectedScopeId: undefined
      });
    }
  };
  if (isLoading || !metrics) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]" data-id="element-353">
        <div className="flex flex-col items-center" data-id="element-354">
          <div className="w-12 h-12 rounded-xl bg-[#B8960C]/10 flex items-center justify-center mb-4" data-id="element-355">
            <Loader2 className="h-6 w-6 animate-spin text-[#B8960C]" data-id="element-356" />
          </div>
          <p className="text-sm text-[#706E6B]" data-id="element-357">Loading dashboard...</p>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#F5F5F5]" data-id="element-358">
      <FilterBar filters={filters} setFilters={setFilters} officers={officers} onRefresh={handleRefresh} data-id="element-359" />

      <main className="w-full px-6 py-8" data-id="element-360">
        {/* Page Header */}
        <div className="mb-6" data-id="element-361">
          <h1 className="text-2xl font-semibold text-[#181818] mb-1" data-id="element-362">
            Performance Leaderboard
          </h1>
          <p className="text-[#706E6B]" data-id="element-363">
            Ranked coaching profiles and lead source ROI
          </p>
        </div>

        {/* Team Summary */}
        <TeamSummaryBar metrics={metrics.officerMetrics} data-id="element-364" />

        {/* Compact Funnel Strip */}
        <div className="mb-10" data-id="element-365">
          <ThroughputFunnel metrics={metrics.funnelMetrics} opportunities={filteredOpportunities} data-id="element-366" />
        </div>

        {/* Leaderboards Side by Side */}
        <div className="grid grid-cols-2 gap-6" data-id="element-367">
          {/* Team Leaderboard */}
          <TeamLeaderboard teamMetrics={metrics.teamMetrics} onTeamSelect={handleTeamSelect} selectedTeamId={(filters.scopeType === 'Team Lead' || filters.scopeType === 'Loan Officer') && filters.selectedScopeId ? (() => {
          if (filters.scopeType === 'Team Lead') return filters.selectedScopeId;
          // Find the team lead for this officer
          const officer = officers.find(o => o.id === filters.selectedScopeId);
          return officer?.teamLeadId || null;
        })() : null} onOfficerSelect={officerId => {
          if (officerId) {
            const officer = officers.find(o => o.id === officerId);
            setFilters({
              ...filters,
              scopeType: 'Loan Officer',
              selectedScopeId: officerId
            });
          } else {
            // Go back to team level — find current team
            const currentOfficer = officers.find(o => o.id === filters.selectedScopeId);
            const teamLeadId = currentOfficer?.teamLeadId;
            if (teamLeadId) {
              setFilters({
                ...filters,
                scopeType: 'Team Lead',
                selectedScopeId: teamLeadId
              });
            } else {
              setFilters({
                ...filters,
                scopeType: 'All',
                selectedScopeId: undefined
              });
            }
          }
        }} selectedOfficerId={filters.scopeType === 'Loan Officer' && filters.selectedScopeId ? filters.selectedScopeId : null} data-id="element-368" />

          {/* Lead Source Leaderboard */}
          <LeadSourceLeaderboard leads={filteredLeads} opportunities={filteredOpportunities} activeSource={filters.leadSources.length === 1 ? filters.leadSources[0] : null} onSourceClick={source => {
          if (filters.leadSources.length === 1 && filters.leadSources[0] === source) {
            setFilters({
              ...filters,
              leadSources: []
            });
          } else {
            setFilters({
              ...filters,
              leadSources: [source]
            });
          }
        }} data-id="element-369" />
        </div>
      </main>
    </div>;
}